import React, { StrictMode, Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { base_path } from "./environment";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../src/style/css/feather.css";
import "../src/index.scss";
import { Provider } from "react-redux";
import "../src/style/icon/boxicons/boxicons/css/boxicons.min.css";
import "../src/style/icon/weather/weathericons.css";
import "../src/style/icon/typicons/typicons.css";
import "../src/style/icon/fontawesome/css/fontawesome.min.css";
import "../src/style/icon/fontawesome/css/all.min.css";
import "../src/style/icon/ionic/ionicons.css";
import "../src/style/icon/tabler-icons/webfont/tabler-icons.css";
import ALLRoutes from "./router/router";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js";
import { store, persistor } from './redux/store';
import { PersistGate } from "redux-persist/integration/react";
import AppWrapper from "./context/AppWrapper";
import { ConfigProvider } from "antd";
import './config/i18n';

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter basename={base_path}>
        <Suspense fallback={<div>Loading translations...</div>}>
          <ConfigProvider theme={{
            token: {
              colorPrimary:   "#563a9d",
            },
            components: {
              Input: {
                controlHeight: 38,
                borderRadius: 8,
              },
              Select: {
                controlHeight: 38,
                borderRadius: 8,
              },
              DatePicker: {
                controlHeight: 38,
                borderRadius: 8,
              },
              InputNumber: {
                controlHeight: 38,
                borderRadius: 8,
              },
            },
          }}>
            <AppWrapper>
              <ALLRoutes />
            </AppWrapper>
          </ConfigProvider>
        </Suspense>
      </BrowserRouter>
    </PersistGate>
    </Provider>
  </React.StrictMode>
);
